// extracted by mini-css-extract-plugin
export default {"container":"Header_container__vI36D","heading":"Header_heading__ni+IL","right":"Header_right__lXdsR"};